<template>
  <div class="base-navigation">
    <div class="top-view">
      <div class="row-1">
        <img style="width: 58px;" src="../../assets/img/set-2025.png"/>
        <div class="col">
          <div style="font-size: 24px;font-weight: bold">标准化文件编写工具软件</div>
          <div style="font-size: 16px;padding-top: 6px;">Standardizing document Editing Tool</div>
        </div>
      </div>
    </div>

    <div class="base-navigation-view">
      <a :class="getNavActive('index')" href="/">
        <img src="../../assets/img/nav-home-icon.png"/>
        首页</a>
      <a :class="getNavActive('download')" target="_blank" href="/download">
        <img src="../../assets/img/nav-download-icon.png" style="width: 23px;height: 23px;"/>
        软件下载</a>
      <a class="nav-btn" target="_blank" href="https://set2025.com/help">
        <img src="../../assets/img/nav-help-icon.png"/>
        帮助手册</a>
      <a class="nav-btn" target="_blank" style="min-width: 150px;"
         href="https://set2025.com/help/qna/install.html">
        <img src="../../assets/img/nav-question-icon.png" style="width: 20px;height: 20px;"/>
        常见问题</a>
      <a class="nav-btn" target="_blank" style="min-width: 150px;"
         href="https://work.weixin.qq.com/kfid/kfcc7e45daf1d1ae466">
        <img src="../../assets/img/nav-service-icon.png"/>
        在线客服</a>

      <div class="user-panel">
        <template v-if="!isLoggedIn">
          <a class="login-btn" href="/login">注册/登录</a>
        </template>
        <template v-else>
          <!--            <el-dropdown>-->

          <!--              <template #dropdown>-->
          <!--                <el-dropdown-item @click="goUserCenter">用户中心</el-dropdown-item>-->
          <!--                <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>-->
          <!--              </template>-->
          <!--            </el-dropdown>-->
          <!--            -->
          <div class="user-info-view">
            <span class="user-name">{{ userName }}</span>
            <div class="btn-list">
              <div @click="goUserCenter" class="btn"
                   style="border-top-left-radius: 10px;border-top-right-radius: 10px;">用户中心
              </div>

              <div @click="handleLogout" class="btn"
                   style="border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">退出登录
              </div>
            </div>
          </div>

        </template>
      </div>
    </div>


  </div>
</template>

<script>


import {getToken, removeToken} from "@/utils/auth";
import api from "@/api";
import eventBus from "@/utils/eventBus";
import {Pointer} from "@element-plus/icons-vue";

export default {
  name: 'Nav',
  components: {Pointer},
  data() {
    return {
      nav: '',
      isLoggedIn: false,
      userName: '',
      userInfo: {}
    }
  },

  mounted() {
    this.checkLoginStatus()
    eventBus.on('checkLoginStatus', this.checkLoginStatus)
  },
  beforeUnmount() {
    // 移除事件监听
    eventBus.off('checkLoginStatus', this.checkLoginStatus)
  },

  watch: {
    $route: {
      handler(to) {
        this.nav = to.meta.nav || ''
        this.checkLoginStatus()
      },
      immediate: true
    },
  },

  methods: {

    getNavActive(currNav) {
      if (currNav === this.nav) {
        return 'nav-btn active'
      }
      return 'nav-btn'
    },

    async checkLoginStatus() {
      const token = getToken()

      this.isLoggedIn = !!token
      console.log(this.isLoggedIn)

      if (this.isLoggedIn) {
        try {
          const userInfoStr = localStorage.getItem("userInfo")
          if (userInfoStr) {
            const userInfo = JSON.parse(userInfoStr)
            this.userInfo = userInfo
            this.userName = userInfo.userName
            return
          }
          const {code, data} = await api.getUserInfo({
            headers: {
              Authorization: `Bearer ${token}`
            }
          });

          console.log('获取用户信息成功:', data)
          // 添加响应状态和数据结构校验
          if (code === 0 && data?.userName) {
            this.userName = data.userName || data.mobile || '已登录用户';
            // 将用户信息存储到本地缓存
            localStorage.setItem('userInfo', JSON.stringify(data))
          } else {
            console.error('获取用户信息失败:', data?.message || '未知错误')
            this.handleLogout()
          }
        } catch (error) {
          console.error('接口请求异常:', error)
          this.handleLogout()
        }
      } else {
        this.userName = '未登录'
        sessionStorage.removeItem('userInfo')
      }
    },
    goUserCenter() {
      this.$router.push('/user-center')
    },
    handleLogout() {
      removeToken()
      localStorage.removeItem('userInfo')
      this.isLoggedIn = false
      this.userName = '未登录'
      // 触发全局状态更新
      eventBus.emit('loginStatusChanged', false)
      this.$router.push('/index');
    },

  }

}
</script>
<style lang="scss" scoped>
.user-panel {
  position: fixed;
  top: 35px;
  right: 10px;

  .login-btn {
    background: linear-gradient(to right, #4B9FFF, #5A7FEB);
    font-size: 15px;
    border-radius: 4px;
    padding-bottom: 4px;
    color: #FFFFFF;
    width: 100px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-btn:hover {
    width: 105px;
    height: 32px;
  }
}

.user-info-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  width: 160px;
  position: fixed;
  top: 35px;
  right: 10px;

  .user-name {
    color: black;
    font-weight: bold;
    font-size: 18px;
  }

  .btn-list {

    flex-direction: column;
    align-items: center;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    margin-top: 15px;
    border-radius: 10px;
    user-select: none;
    display: none;

    .btn {
      color: #666666;
      padding: 8px 20px;
      height: 30px;
      font-size: 15px;
    }

    .btn:hover {
      background: #e0edfc;
      color: #000000;
    }
  }
}

.user-info-view:hover {
  .btn-list {
    display: flex;
  }
}

.base-navigation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #0257B2;
  position: fixed;
  top: 0;
  z-index: 2;
  min-width: 1000px;

  .top-view {
    height: 100px;
    width: 100%;
    background: #FFF;
    display: flex;

    .row-1 {
      margin: 0 auto;
      width: 1000px;
      display: flex;
      justify-content: start;
      align-items: center;

      .col {
        display: flex;
        flex-direction: column;
        margin-left: 10px;

        .row {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .nav-btn:hover {
    background: #32ADE6;
  }

  .base-navigation-view {
    width: 1000px;
    height: 51px;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }

  .nav-btn {
    height: 100%;
    width: 136px;
    margin-right: 38px;
    color: #FFFFFF;
    background: #0257B2;
    font-size: 16px;
    border-radius: 2px;
    user-select: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
  }

  .active {
    background: #4B9FFF;
  }
}
</style>
